

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {
    CurProjectDataClass,
    IGoal,
    KatoItem,
    ValidationErrors,
} from "./gip-types";
import { IAbp } from "@/modules/budget/bip/bip-types";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import CheckboxMultiselect from "@/components/custom/CheckboxMultiselect.vue";
import GoalCard from "./goal-card.vue";

@Component({
    name: "currentProjectCard",
    components: {
        multiselect: Multiselect,
        DatePicker,
        "checkbox-multiselect": CheckboxMultiselect,
        GoalCard,
    },
})
export default class CurrentProjectCard extends Vue {
    $refs!: {
        goalTpCard: HTMLFormElement;
    };
    @Prop({
        required: true,
        default: () => new CurProjectDataClass(),
    })
    private tp!: CurProjectDataClass;
    @Prop({
        type: String,
        default: "view",
        validator: (value: string) =>
            ["view", "edit", "create"].includes(value),
    })
    private mode!: string;
    @Prop({ required: true }) activeTab!: number;
    @Prop({ required: true }) save!: boolean;
    @Prop({ required: true }) validationErrors!: ValidationErrors;
    private localValidationErrors: any = { ...this.validationErrors };
    @Prop({ required: true }) private abpOptions!: IAbp[];
    private localAbpOptions: IAbp[] = [...this.abpOptions];
    @Prop({ required: true, default: null }) private selectedAbp!: any | null;

    @Prop({ required: true, default: null }) private selectedType!: {
        code: string;
        text: string;
    } | null;

    @Prop({ required: true, default: () => [] }) private prgOptions!: any[];
    private localPrgOptions: any[] = [...this.prgOptions];
    @Prop({ required: true, default: null }) private selectedPrg!: any | null;

    @Prop({ required: true, default: () => [] }) private regionOptions!: any[];
    private localRegionOptions: any[] = [...this.regionOptions];
    @Prop({ required: true, default: null }) private selectedRegion!:
        | any
        | null;

    @Prop({ required: true }) private katoOptions!: KatoItem[];
    private localKatoOptions: KatoItem[] = [...this.katoOptions];
    @Prop({ required: true, default: () => [] })
    private selectedKato!: KatoItem[] | null;

    @Prop({ required: true }) private projectPrgOptions!: any[];
    private localProjectPrgOptions: any[] = [...this.projectPrgOptions];
    @Prop({ required: true, default: () => [] })
    private selectedProjectPrg!: any[];

    @Prop({ required: true }) private unitOptions!: any[];
    private localUnitOptions: any[] = [...this.unitOptions];
    @Prop({ required: true, default: null }) private selectedUnit!: any | null;

    @Prop({ required: true }) private fundingSrcOptions!: any[];
    private localFundingSrcOptions: any[] = [...this.fundingSrcOptions];
    @Prop({ required: true, default: null }) private selectedFunding!:
        | any
        | null;

    @Prop({ required: true }) private branchOptions!: any[];
    private localBranchOptions: any[] = [...this.branchOptions];
    @Prop({ required: true, default: null }) private selectedBranch!:
        | any
        | null;

    @Prop({ required: true }) private indicatorOptions!: any[];
    private localIndicatorOptions: any[] = [...this.indicatorOptions];
    @Prop({ default: null }) private selectedIndicator!: any | null;

    private minDate: Date = new Date(new Date().getFullYear() - 10, 0);
    private maxDate: Date = new Date(new Date().getFullYear() + 10, 11);
    private showConceptForm: boolean = false;
    private showTpGoalForm: boolean = false;
    private newGoalList: IGoal[] = [];
    private selectedTpGoal: any = null;
    @Prop({ required: true, default: true })
    private backProjectCardForm!: boolean;
    private showDelGoalModal: boolean = false;
    private goalToDeleteIndex: number | null = null;

    private dateFromForInput: Date | null = new Date(
        new Date().getFullYear(),
        new Date().getMonth()
    );

    private dateToForInput: Date | null = new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1
    );

    get userId() {
        return store.getters.user_uuid;
    }

    private get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    get currentType(): string | null {
        return this.selectedType?.code || null;
    }

    set currentType(value: string | null) {
        const newValue = value
            ? {
                  code: value,
                  text:
                      value === "current"
                          ? "this.$t('modules.bank_projects.filter_params.type_exp.cur_prj')"
                          : "this.$t('modules.bank_projects.filter_params.type_exp.other_prj')",
              }
            : null;
        this.$emit("update:selectedType", newValue);
    }

    get currentAbp() {
        if (this.selectedAbp) {
            return this.selectedAbp;
        }
        const stored = this.tp?.abp;
        const matchedOption = this.localAbpOptions.find(
            (option: any) => option.text === stored || option.text_kk === stored
        );
        return matchedOption || null;
    }

    set currentAbp(value: any | null) {
        this.$emit("update:selectedAbp", value);
    }

    get currentRegion() {
        if (this.selectedRegion) {
            return this.selectedRegion;
        }
        const stored = this.tp?.budgetRegion;
        const matchedOption = this.localRegionOptions.find(
            (option: any) => option.text === stored || option.text_kk === stored
        );
        return matchedOption || null;
    }

    set currentRegion(value: any | null) {
        this.$emit("update:selectedRegion", value);
    }

    get currentPrg() {
        if (this.selectedPrg) {
            return this.selectedPrg;
        }
        const stored = this.tp?.prg;
        return (
            this.localPrgOptions.find(
                (option) => option.text === stored || option.text_kk === stored
            ) || null
        );
    }

    set currentPrg(value: any | null) {
        this.$emit("update:selectedPrg", value);
    }

    get currentKato(): string[] {
        if (Array.isArray(this.selectedKato) && this.selectedKato.length) {
            return this.selectedKato.map((item: KatoItem) => item.code);
        }

        if (Array.isArray(this.tp.location) && this.tp.location.length) {
            return [...this.tp.location];
        }

        return [];
    }

    set currentKato(codes: string[]) {
        const uniqueCodes = Array.from(new Set(codes));
        this.$emit(
            "update:selectedKato",
            this.localKatoOptions.filter((o: KatoItem) =>
                uniqueCodes.includes(o.code)
            )
        );
        this.tp.location = uniqueCodes;
    }

    get selectedKatoObjects() {
        return (this.tp.location || []).map(
            (code) =>
                this.localKatoOptions.find((o) => o.code === code) || {
                    code,
                    name: code,
                }
        );
    }

    private searchKatoQuery: string = "";

    private get filteredKatoOptions() {
        const q = (this.searchKatoQuery || "").toLowerCase();
        const isKk = this.curLanguage === "kk";
        const result = (this.katoOptions || [])
            .map((o) => {
                const label = isKk
                    ? (o as any).text_kk ??
                      (o as any).name_kk ??
                      (o as any).text ??
                      (o as any).name ??
                      ""
                    : (o as any).text ?? (o as any).name ?? "";
                return { label, value: o.code };
            })
            .filter((item) => item.label.toLowerCase().includes(q));
        return result;
    }

    private removeSelectedKato(code: string) {
        this.currentKato = (this.currentKato || []).filter((c) => c !== code);
    }

    get currentBranch() {
        if (this.selectedBranch) {
            return this.selectedBranch;
        }
        const stored = this.tp?.projectBranch;
        const matchedOption = this.localBranchOptions.find(
            (option: any) =>
                option.name_ru === stored || option.name_kz === stored
        );
        return matchedOption || null;
    }

    set currentBranch(value: any | null) {
        this.$emit("update:selectedBranch", value);
    }

    get currentFundingSrc() {
        if (this.selectedFunding) {
            return this.selectedFunding;
        }
        const stored = this.tp?.srcFunding;
        const matchedOption = this.localFundingSrcOptions.find(
            (option: any) =>
                option.name_ru === stored || option.name_kz === stored
        );
        return matchedOption || null;
    }

    set currentFundingSrc(value: any | null) {
        this.$emit("update:selectedFunding", value);
    }

    get selectedProjectPrgObjects() {
        return (this.tp.projectConcept || []).map(
            (code) =>
                this.localProjectPrgOptions.find((o) => o.code === code) || {
                    code,
                    name_ru: code,
                }
        );
    }

    get currentProjectPrg(): string[] {
        if (
            Array.isArray(this.selectedProjectPrg) &&
            this.selectedProjectPrg.length
        ) {
            return [...this.selectedProjectPrg];
        }

        if (
            Array.isArray(this.tp.projectConcept) &&
            this.tp.projectConcept.length
        ) {
            return [...this.tp.projectConcept];
        }

        return [];
    }

    set currentProjectPrg(codes: string[]) {
        const uniqueCodes = Array.from(new Set(codes));
        this.$emit("update:selectedProjectPrg", uniqueCodes);
        this.tp.projectConcept = uniqueCodes;
    }

    private searchConceptQuery: string = "";

    private get filteredConceptOptions() {
        const isKk = this.curLanguage === "kk";
        const q = this.searchConceptQuery.toLowerCase();
        return this.projectPrgOptions
            .filter((o) => {
                const searchField = isKk
                    ? o.name_kz ?? o.name_kz ?? o.name_ru ?? ""
                    : o.name_ru ?? "";
                return searchField.toLowerCase().includes(q);
            })
            .map((o) => ({
                name_ru: o.name_ru,
                name_kk: o.name_kz ?? o.name_kz ?? o.name_ru,
                code: o.code,
            }));
    }

    private removeSelectedConcept(code: string) {
        const updated = (this.currentProjectPrg || []).filter(
            (c) => c !== code
        );
        this.currentProjectPrg = updated;
    }

    private selectedConceptItems: string[] = [];
    private selectAllConcept: boolean = false;

    private openConceptModal() {
        this.showConceptForm = true;
        this.selectedConceptItems = [...this.currentProjectPrg];
    }

    private resetCheckConcepts() {
        this.showConceptForm = false;
        this.resetSelectedConcepts();
    }

    private resetSelectedConcepts() {
        this.selectedConceptItems = [];
        this.selectAllConcept = false;
        this.searchConceptQuery = "";
    }

    private handleAddConcepts() {
        this.currentProjectPrg = [...this.selectedConceptItems];
        this.showConceptForm = false;
    }

    private toggleSelectAll() {
        if (this.selectAllConcept) {
            this.selectedConceptItems = this.filteredConceptOptions.map(
                (item) => item.code
            );
        } else {
            this.selectedConceptItems = [];
        }
        this.selectedProjectPrgObjects.forEach((concept) => {
            concept.check = this.selectedConceptItems.includes(concept.code);
        });
    }

    private updateSelectAll() {
        this.selectedProjectPrgObjects.forEach((concept) => {
            concept.check = this.selectedConceptItems.includes(concept.code);
        });
        this.selectAllConcept =
            this.filteredConceptOptions.length > 0 &&
            this.filteredConceptOptions.every((concept) =>
                this.selectedConceptItems.includes(concept.code)
            );
    }

    get currentUnit() {
        if (this.selectedUnit) {
            return this.selectedUnit;
        }
    }

    set currentUnit(value: any | null) {
        this.$emit("update:selectedUnit", value);
    }

    get currentIndicator() {
        if (this.selectedIndicator) {
            return this.selectedIndicator;
        }
    }

    set currentIndicator(value: any | null) {
        this.$emit("update:selectedIndicator", value);
    }

    get isViewable() {
        return this.mode === "view";
    }

    get isEditable() {
        return this.mode === "edit";
    }

    get isCreatable() {
        return this.mode === "create";
    }

    get yearsInRange() {
        const years = [];
        const startYear = this.tp.dateFromForInput?.getFullYear();
        const endYear = this.tp.dateToForInput?.getFullYear();

        if (startYear && endYear && startYear <= endYear) {
            for (let year = startYear; year <= endYear; year++) {
                years.push(year);
            }
        }
        return years;
    }

    get formattedPlanData(): Array<Record<string, number | null | string>> {
        if (
            !this.tp.dateFromForInput ||
            !this.tp.dateToForInput ||
            !this.tp.plan ||
            this.tp.plan.length === 0
        ) {
            const begYear = this.tp.dateFromForInput?.getFullYear() ?? 0;
            const endYear = this.tp.dateToForInput?.getFullYear() ?? 0;

            if (!begYear || !endYear || begYear > endYear) {
                return [];
            }

            const emptyData: Record<string, number | null> = {};
            for (let year = begYear; year <= endYear; year++) {
                emptyData[`year_${year}`] = null;
            }

            return [emptyData];
        }

        const data: Record<string, number | null> = {};
        this.tp.plan.forEach((p) => {
            const yearKey = `year_${p.year}`;
            const value = this.formatPlanValue(p.value);
            data[yearKey] = isNaN(value) ? null : value;
        });

        return [data];
    }

    get tableFields() {
        const years = this.yearsInRange;
        return years.map((year) => ({
            key: `year_${year}`,
            label: `${year}`,
        }));
    }

    private validatePlanValues(status: boolean): ValidationErrors {
        const errors: ValidationErrors = {};

        this.formattedPlanData.forEach((row) => {
            this.tableFields.forEach((field) => {
                const value = row[field.key];

                if (status) {
                    if (value === undefined || (value && value < "0")) {
                        const errorMessage = String(
                            this.$t(
                                "modules.bank_projects.messages.fill_plan_val_err_msg",
                                { f: field.label || field.key }
                            )
                        );
                        errors[`${field.key}`] = errorMessage;

                        this.makeToast(
                            "danger",
                            errorMessage,
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.saving_err_msg"
                                )
                            )
                        );
                    }
                } else {
                    if (
                        value !== undefined &&
                        typeof value === "number" &&
                        value < 0
                    ) {
                        const errorMessage = String(
                            this.$t(
                                "modules.bank_projects.messages.plan_val_pos_err_msg",
                                { f: field.label || field.key }
                            )
                        );
                        errors[`${field.key}`] = errorMessage;

                        this.makeToast(
                            "danger",
                            errorMessage,
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.saving_err_msg"
                                )
                            )
                        );
                    }
                }
            });
        });

        this.localValidationErrors = errors;
        this.$emit("validation-complete", errors);
        return errors;
    }

    public async created() {
        this.$watch("regionOptions", (newOptions: any) => {
            this.localRegionOptions = [...newOptions];
        });
        this.$watch("abpOptions", (newOptions: any) => {
            this.localAbpOptions = [...newOptions];
        });
        this.$watch("prgOptions", (newOptions: any) => {
            this.localPrgOptions = [...newOptions];
        });
        this.$watch("katoOptions", (newOptions: any) => {
            this.localKatoOptions = [...newOptions];
        });
        this.$watch("branchOptions", (newOptions: any) => {
            this.localBranchOptions = [...newOptions];
        });
        this.$watch("fundingSrcOptions", (newOptions: any) => {
            this.localFundingSrcOptions = [...newOptions];
        });
        this.$watch("projectPrgOptions", (newOptions: any) => {
            this.localProjectPrgOptions = [...newOptions];
        });
        this.$watch("validationErrors", (newErrors: any) => {
            this.localValidationErrors = { ...newErrors };
        });
        this.$watch("tp.srcData", (newValue) => {
            if (newValue === "other") {
                this.resetFilterForOtherType();
                this.resetValidationErrors();
                this.localValidationErrors = {};
                this.$emit("request-abp-without-region");
            } else {
                this.currentRegion = this.localRegionOptions[0];
            }
        });
        this.$watch("tp.dateFromForInput", () => {
            this.validateYearRange("project");
        });

        this.$watch("tp.dateToForInput", () => {
            this.validateYearRange("project");
        });

        this.$watch("tp.period_start_year", (value) => {
            if (value) {
                this.$set(
                    this.validationErrors,
                    "tpData.period_start_year",
                    undefined
                );
            }
        });

        this.$watch("tp.period_end_year", (value) => {
            if (value) {
                this.$set(
                    this.validationErrors,
                    "tpData.period_end_year",
                    undefined
                );
            }
        });
    }

    public mounted() {}

    get goalList(): IGoal[] {
        return this.tp?.goals || [];
    }

    private formatPlanValue(value: any): number {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    }

    private formatNumber(value: number): string {
        return new Intl.NumberFormat("ru-RU", {
            style: "decimal",
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
        }).format(value);
    }

    private disableDate(date: Date | null): boolean {
        if (!date) {
            return true;
        }

        const year = date.getFullYear();
        const month = date.getMonth();

        return (
            year < this.minDate.getFullYear() ||
            year > this.maxDate.getFullYear() ||
            (year === this.minDate.getFullYear() &&
                month < this.minDate.getMonth()) ||
            (year === this.maxDate.getFullYear() &&
                month > this.maxDate.getMonth())
        );
    }

    private formatStartDate(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth();

        const formattedDate = new Date(Date.UTC(year, month, 1));
        return formattedDate.toISOString();
    }

    private formatEndDate(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth();

        const lastDay = new Date(Date.UTC(year, month + 1, 0)).getDate();

        const formattedDate = new Date(Date.UTC(year, month, lastDay));
        return formattedDate.toISOString();
    }

    private formatDateToMMYYYY(date: Date | null | undefined): string {
        if (!date) return "";
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${year}`;
    }

    private validateDateRange(source: string): void {
        if (this.tp.dateFromForInput && this.tp.dateToForInput) {
            if (source === "from") {
                if (this.tp.dateFromForInput > this.tp.dateToForInput) {
                    this.tp.dateToForInput = new Date(this.tp.dateFromForInput);
                }
            } else if (source === "to") {
                if (this.tp.dateToForInput < this.tp.dateFromForInput) {
                    this.tp.dateFromForInput = new Date(this.tp.dateToForInput);
                }
            }

            const minDate = new Date(2000, 0); // Январь 2000
            const maxDate = new Date(9999, 11); // Декабрь 9999

            if (this.tp.dateFromForInput < minDate) {
                this.tp.dateFromForInput = minDate;
            } else if (this.tp.dateFromForInput > maxDate) {
                this.tp.dateFromForInput = maxDate;
            }

            if (this.tp.dateToForInput < minDate) {
                this.tp.dateToForInput = minDate;
            } else if (this.tp.dateToForInput > maxDate) {
                this.tp.dateToForInput = maxDate;
            }
        }
    }

    private extractYear(date: string | Date | null): number | null {
        if (!date) return null;
        const d = new Date(date);
        if (isNaN(d.getTime())) return null;
        return d.getFullYear();
    }

    private validateYearRange(source: string): void {
        const realStart = this.extractYear(this.tp.dateFromForInput);
        const realEnd = this.extractYear(this.tp.dateToForInput);

        let start = this.tp.period_start_year;
        let end = this.tp.period_end_year;

        if (!start || !end || !realStart || !realEnd) return;

        if (source === "from" && start > end) {
            end = start;
        } else if (source === "to" && end < start) {
            start = end;
        }

        // ---- синхронизация с периодом проекта ----
        //  Цели конец проекта
        if (end < realStart) {
            start = realStart;
            end = realStart;
        }
        //  Цели начало проекта
        else if (start > realEnd) {
            start = realEnd;
            end = realEnd;
        }
        // Цели не выходили за пределы периода проекта
        else {
            if (start < realStart) start = realStart;
            if (end > realEnd) end = realEnd;
        }

        // Защита от начало > конец периода целей
        if (start > end) end = start;

        this.tp.period_start_year = start;
        this.tp.period_end_year = end;
    }

    private extractCode(value: string) {
        if (!value || typeof value !== "string") {
            return null;
        }
        const [code] = value.split(" - ");
        return code ? parseInt(code.trim()) : null;
    }

    private extractRegionCode(value: string): string | null {
        if (!value || typeof value !== "string") {
            return null;
        }
        const [code] = value.split(" - ");
        return code?.trim() || null;
    }

    private getBranchCodeByName(name: string): string | null {
        const matchedOption = this.localBranchOptions.find(
            (option: any) =>
                option.name_ru === name ||
                option.name_kz === name ||
                option.name_kk === name
        );

        return matchedOption?.code || null;
    }

    private getFundingCodeByName(name: string): string | null {
        const matchedOption = this.localFundingSrcOptions.find(
            (option: any) =>
                option.name_ru === name ||
                option.name_kz === name ||
                option.name_kk === name
        );
        return matchedOption?.code || null;
    }

    get periodYears(): number[] {
        if (!this.tp?.period_start_year || !this.tp?.period_end_year) return [];
        const start = this.tp.period_start_year;
        const end = this.tp.period_end_year;
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }

    private openGoalForm(goal?: any) {
        const missingFields: string[] = [];

        if (!this.tp?.period_start_year) {
            missingFields.push(
                String(
                    this.$t("modules.bank_projects.messages.period_goal_start")
                )
            );
            this.$set(
                this.validationErrors,
                "tpData.period_start_year",
                String(
                    this.$t("modules.bank_projects.messages.require_field_msg")
                )
            );
        }

        if (!this.tp?.period_end_year) {
            missingFields.push(
                String(
                    this.$t("modules.bank_projects.messages.period_goal_finish")
                )
            );
            this.$set(
                this.validationErrors,
                "tpData.period_end_year",
                String(
                    this.$t("modules.bank_projects.messages.require_field_msg")
                )
            );
        }

        if (missingFields.length > 0) {
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.bank_projects.messages.missing_field_err",
                        { f: missingFields.join(", ") }
                    )
                ),
                String(this.$t("modules.bank_projects.messages.msg"))
            );
            return false;
        }
        if (goal) {
            const g = JSON.parse(JSON.stringify(goal));
            g.results =
                g.results?.map((res: any) => ({
                    ...res,
                    unit:
                        this.unitOptions.find((u) => u.id === res.unit) || null,
                    indicator:
                        this.indicatorOptions.find(
                            (i) => i.id === res.indicator_id
                        ) || null,
                })) || [];
            this.selectedTpGoal = { ...g };
        } else {
            this.selectedTpGoal = {
                id: null,
                name_ru: "",
                name_kz: "",
                tasks: [],
                results: [],
            };
        }

        this.$nextTick(() => {
            if (this.$refs.goalTpCard) {
                (this.$refs.goalTpCard as any).initGoal(this.selectedTpGoal);
            }
        });

        this.$emit("update:backProjectCardForm", false);
        this.showTpGoalForm = true;
    }

    handleResetTaskList() {
        if (this.$refs.goalTpCard) {
            (this.$refs.goalTpCard as any).resetTaskList();
        }
    }

    private removeSelectedGoal(index: number) {
        if (
            this.goalToDeleteIndex !== null &&
            this.goalToDeleteIndex >= 0 &&
            this.goalToDeleteIndex < this.goalList.length
        ) {
            this.goalList.splice(this.goalToDeleteIndex, 1);
        }
        this.goalToDeleteIndex = null;
    }

    private openGoalDelModal(index: number) {
        this.goalToDeleteIndex = index;
        this.showDelGoalModal = true;
    }

    private cancelGoalModalDel() {
        this.showDelGoalModal = false;
        this.goalToDeleteIndex = null;
    }

    getFormData() {
        const years = this.yearsInRange;
        const planValues = years.map((year) => ({
            year: year,
            value: Number(this.formattedPlanData[0][`year_${year}`]) || 0,
        }));

        return {
            ...(this.tp.id && { id: this.tp.id }),
            budget_region:
                this.selectedRegion?.code ||
                this.extractRegionCode(this.tp.budgetRegion) ||
                null,
            name_kz: this.tp.nameKk,
            name_ru: this.tp.nameRu,
            abp: this.selectedAbp?.abp || this.extractCode(this.tp.abp) || null,
            is_archive: this.tp.projectStatus === "archived",
            funding:
                this.selectedFunding?.code ||
                this.getFundingCodeByName(this.tp.srcFunding) ||
                null,
            amount_budget: this.tp.budgetAmount,
            project_type: this.tp.srcData === "current" ? "current" : "other",
            branch:
                this.selectedBranch?.code ||
                this.getBranchCodeByName(this.tp.projectBranch) ||
                null,
            prg: this.selectedPrg?.prg || this.extractCode(this.tp.prg) || null,
            concepts: this.selectedProjectPrgObjects.length
                ? this.selectedProjectPrgObjects.map((item) => item.code)
                : Array.isArray(this.tp.projectConcept)
                ? [...this.tp.projectConcept]
                : [],
            begin_date: this.tp.dateFromForInput
                ? this.formatStartDate(this.tp.dateFromForInput)
                : null,
            end_date: this.tp.dateToForInput
                ? this.formatEndDate(this.tp.dateToForInput)
                : null,
            locations: this.selectedKatoObjects.length
                ? this.selectedKatoObjects.map((item) => item.code)
                : Array.isArray(this.tp.location)
                ? [...this.tp.location]
                : [],
            user_id: this.userId,
            date_act_commission:
                this.tp.actDate !== null
                    ? this.formatStartDate(this.tp.actDate)
                    : null,
            plan_values: planValues,
            goals: this.goalList.map((g) => ({
                name_ru: g.name_ru,
                name_kz: g.name_kz,
                tasks: g.tasks || [],
                results: g.results
                    ? g.results.map((r) => ({
                          ...r,
                          indicator_id:
                              typeof r.indicator === "object"
                                  ? r.indicator.id
                                  : r.indicator,
                          unit: typeof r.unit === "object" ? r.unit.id : r.unit,
                      }))
                    : [],
            })),
            period_start_year: this.tp.period_start_year,
            period_end_year: this.tp.period_end_year,
        };
    }

    public getGoalCardData() {
        const goalCardComponent = this.$refs.goalTpCard as any;
        if (goalCardComponent && goalCardComponent.getGoalData) {
            return goalCardComponent.getGoalData();
        }
        return {};
    }

    private idCounter = 0;

    private generateUniqueId(): number {
        return Date.now() + this.idCounter++;
    }

    public saveGoalsFromGoalCard() {
        const goalData = this.getGoalCardData();
        if (!goalData.name_ru || !goalData.name_ru.trim()) return;

        if (this.selectedTpGoal.id) {
            const index = this.goalList.findIndex(
                (g) => g.id === this.selectedTpGoal.id
            );
            if (index !== -1) {
                this.goalList.splice(index, 1, {
                    ...goalData,
                    id: this.selectedTpGoal.id,
                });
            }
        } else {
            this.goalList.push({
                ...goalData,
                id: this.generateUniqueId(),
            });
        }

        this.showTpGoalForm = false;
    }

    handleValidationComplete(payload: any) {
        let newErrors;

        if (payload.context === "goal") {
            newErrors = payload.errors;
        } else {
            newErrors = payload;
        }

        this.$emit("update:validationErrors", newErrors);
        this.$emit("validation-complete", newErrors);
    }

    private backToGoals() {
        this.showTpGoalForm = false;
        this.$emit("update:backProjectCardForm", true);
    }

    private resetGipData() {
        this.tp = new CurProjectDataClass();
    }

    private resetFilterForOtherType() {
        this.tp.budgetAmount = 0;
        this.currentBranch = null;
        this.currentRegion = null;
        this.currentPrg = null;
        this.currentProjectPrg = [];
        this.currentKato = [];
    }

    private resetValidationErrors() {
        Object.keys(this.validationErrors).forEach((key) => {
            this.$set(this.validationErrors, key, undefined);
        });
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            solid: true,
            appendToast: true,
        });
    }
}
